<template>
  <div class="personal-container flex-row">
    <div class="box">
      <div class="title">个人信息</div>
      <div class="subtitle"><i class="el-icon-warning-outline"></i>个人信息与其它数据密切关联，请勿随意修改</div>
      <div class="flex-row">
        <el-button type="primary" icon="el-icon-back" @click="$router.back()">返回</el-button>
        <el-button type="primary" icon="el-icon-finished" @click="save('info')">保存</el-button>
      </div>
      <el-divider></el-divider>
      <div class="content">
        <div class="upload flex-column">
          <div class="avatar">
            <img v-if="userInfo.headUrl" :src="baseUrl + userInfo.headUrl">
            <img v-else src="../../assets/avatar.jpg">
          </div>
          <el-upload action="#" :http-request="requestUpload" :before-upload="beforeUpload" :show-file-list="false">
            <el-button size="mini">上传头像</el-button>
          </el-upload>
        </div>
        <el-form :model="userInfo" label-width="80px" ref="infoForm">
          <el-form-item label="登录名">
            <el-input v-model="userInfo.loginName" disabled></el-input>
          </el-form-item>
          <el-form-item label="用户类别">
            <el-select v-model="userInfo.userDict" disabled>
              <el-option label="学生" value="0"></el-option>
              <el-option label="家长" value="1"></el-option>
              <el-option label="教师" value="2"></el-option>
              <el-option label="管理员" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别">
            <el-select v-model="userInfo.gender" disabled>
              <el-option label="女" value="0"></el-option>
              <el-option label="男" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model="userInfo.name"></el-input>
          </el-form-item>
          <el-form-item label="显示名">
            <el-input v-model="userInfo.displayName"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="userInfo.mobilePhone"></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input v-model="userInfo.cardNum"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="box">
      <div class="title">修改密码</div>
      <div class="subtitle"><i class="el-icon-lock"></i>如忘记原始密码，请联系管理员重置密码后再修改</div>
      <div class="flex-row">
        <span></span>
        <el-button type="primary" icon="el-icon-finished" @click="save('pass')">保存</el-button>
      </div>
      <el-divider></el-divider>
      <el-form :model="form" :rules="rules" ref="form" hide-required-asterisk>
        <el-form-item label="原始密码" prop="password">
          <el-input type="password" show-password v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" show-password v-model="form.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input type="password" show-password v-model="form.confirmPassword"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog :visible.sync="dialogVisible" title="头像裁剪">
      <div class="cropper flex-column">
        <vueCropper ref="cropper" :img="option.img" :info="option.info" :outputType="option.outputType"
          :autoCrop="option.autoCrop" :canMove="option.canMove" :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight" :fixedBox="option.fixedBox" :centerBox="option.centerBox"
          @realTime="realTime" />
        <div class="tool">
          <el-button size="mini" icon="el-icon-refresh-left" @click="rotateLeft"></el-button>
          <el-button size="mini" icon="el-icon-refresh-right" @click="rotateRight"></el-button>
          <el-button size="mini" icon="el-icon-zoom-out" @click="changeScale(-1)"></el-button>
          <el-button size="mini" icon="el-icon-zoom-in" @click="changeScale(1)"></el-button>
        </div>
      </div>
      <div class="preview flex-column">
        <div class="square">
          <img :src="previews.url" :style="previews.img" alt="">
        </div>
        <div class="circle">
          <img :src="previews.url" :style="previews.img" alt="">
        </div>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="upload">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updateUserInfoApi, updatePasswordApi, uploadApi } from './api'
const { baseURL } = projectConfig
export default {
  name: 'Personal',
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value) {
        if (value === this.form.newPassword) {
          callback()
        } else {
          callback(new Error('两次输入的密码不一致'))
        }
      } else {
        callback(new Error('请输入确认密码'))
      }
      callback()
    }
    return {
      baseURL,
      baseUrl: localStorage.getItem('baseUrl'),
      uploadParams: { token: localStorage.getItem('sys_token') },
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      dialogVisible: false,
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputType: 'png', // 裁剪生成图片的格式
        autoCrop: true, // 是否默认生成截图框
        canMove: false, // 上传图片是否可以移动
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        centerBox: true, // 截图框是否被限制在图片里面
      },
      previews: {},
      form: {
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        password: [{ required: true, message: '请输入原始密码', trigger: 'change' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'change' }],
        confirmPassword: [{ validator: validateConfirmPassword, trigger: 'change' }]
      }
    }
  },
  methods: {
    beforeUpload(file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png')
        return this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      if (file.size / 1024 / 1024 > 2)
        return this.$message.error('上传头像图片大小不能超过 2MB!')
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.option.img = reader.result
        this.loading = false
        this.dialogVisible = true
      }
    },
    requestUpload() { },
    upload() {
      this.$refs.cropper.getCropBlob(async data => {
        const file = new window.File([data], this.userInfo.name + '.png', { type: 'image/png' })
        const formData = new FormData()
        formData.append('file', file)
        const { data: { filePath } } = await uploadApi(formData)
        this.userInfo.headUrl = filePath
        this.dialogVisible = false
      })
    },
    realTime(data) {
      this.previews = data
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    save(type) {
      if (type === 'info') {
        this.$refs.infoForm.validate(async valid => {
          if (valid) {
            await updateUserInfoApi(this.userInfo)
            this.$message.success('保存成功')
          }
        })
      } else {
        this.$refs.form.validate(async valid => {
          if (valid) {
            await updatePasswordApi(this.form)
            this.$message.success('保存成功')
            this.$refs.form.resetFields()
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-container {
  height: 100vh;
  background: no-repeat center/cover url(../../assets/home.png);
  padding: 50px;
  gap: 50px;

  .box {
    height: 100%;
    width: 50%;
    overflow: auto;
    border: 1px solid #eee;
    padding: 30px;
    backdrop-filter: blur(10px);

    .title {
      font-size: 30px;
      color: $titleColor;
    }

    .subtitle {
      font-size: 13px;
      margin: 10px 0 30px;
      color: $contentColor;

      i {
        margin-right: 4px;
      }
    }

    .el-divider {
      margin: 10px 0 50px;
      height: 1.5px;
    }

    .content {
      display: flex;
      align-items: flex-start;
    }

    .upload {
      gap: 10px;

      .avatar {
        width: 150px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .el-form {
      width: 400px;
      margin: auto;

      .el-select {
        width: 100%;
      }

      ::v-deep.el-form-item__label {
        color: $pointColor;
        font-weight: bold;
      }
    }
  }

  ::v-deep.el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 50px;

    .cropper {
      width: 600px;
      height: 450px;
      gap: 10px;
    }

    .preview {
      gap: 50px;

      div {
        width: 180px;
        height: 180px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }

        &.circle {
          border-radius: 50%;
        }
      }
    }
  }

  ::v-deep .el-button {
    border-radius: 0;

    &--primary {
      background-color: $homeRed;
      border-color: $homeRed;

      &:hover {
        background-color: lighten($homeRed, 5%);
        border-color: lighten($homeRed, 5%);
      }

      &:active {
        background-color: darken($homeRed, 5%);
        border-color: darken($homeRed, 5%);
      }
    }
  }

  ::v-deep .el-input__inner {
    border-radius: 0;

    &:focus {
      border-color: $homeRed;
    }
  }
}
</style>